import * as React from 'react';

const PublishIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 232 320" {...props}>
        <style>
            {
                '\n        .publish-illustration_svg__st1{fill:#f05537}.publish-illustration_svg__st2{fill:#324b8c}.publish-illustration_svg__st3{fill:#fff}.publish-illustration_svg__st4{fill:#1e0a3c}\n    '
            }
        </style>
        <path d="M0 6.8v308.6c159.9-45.3 139-277 0-308.6z" fill="#dbdae3" />
        <path
            className="publish-illustration_svg__st1"
            d="M199.9 129.9s1.7-2.1 3.1-1.5c1 .4-.6 4.2-.6 5.3s.9 6.1.9 6.1l-3.4-3.2v-6.7z"
        />
        <path
            className="publish-illustration_svg__st2"
            d="M70.7 269.9L75 320h91.9l3.8-52.1-100 2z"
        />
        <path
            className="publish-illustration_svg__st3"
            d="M177.5 127c-5.4-4.5-36.6-10.7-36.6-10.7l-32.9-2.2s-35.1-.6-41.1 4.8c-4.9 4.4-5.8 62.2 1.7 117 1.3 9.3-.2 29 1.7 36.7 1.5 5.7 76 8.6 100.1-1.6-.1-.1 15.7-136.7 7.1-144z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M159.1 75.5c-.4-1.2-1.1-2-1.9-2-.8 0-1.6.5-2.2 1.7-.6 1-1 2.4-1.1 4-.1 1.5 0 3 .4 4.2.4 1.2 1.1 2 1.9 2h.1c.7 0 1.5-.6 2.1-1.7.6-1 1-2.4 1.1-4 .1-1.6 0-3.1-.4-4.2zm-2.1-1.3c.6 0 1 .6 1.4 1.5.4 1.1.5 2.4.4 3.9-.1 1.4-.5 2.7-1 3.7-.5.9-1 1.3-1.5 1.3s-1-.6-1.3-1.5c-.4-1.1-.5-2.4-.4-3.9.1-1.4.5-2.7 1-3.7.4-.8.9-1.3 1.4-1.3z"
        />
        <path
            className="publish-illustration_svg__st1"
            d="M140.8 116.2c-1.2-6.5-.6-9.8-.1-13 .1-.6.7-1 1.3-1 6.5 1.1 9.5.5 10.9-1.7 1.2-2 1.7-8.3 1.9-10.4 0-.5.3-.9.8-1 .6-.2 1.5-.5 2.2-.9.6-.3.9-.9.6-1.5-.8-1.9-1.7-5.5-2-6.4v-.4c.2-1.8 1.5-15.9 1-18.1-.7-3.8-12.6-24.4-35.2-14.5C100 57 109 80.2 113 88.4c0 .1 0 .2.1.2 3.4 14.9-3.2 23.3-5.2 25.4-.4.4.1.4.4.8 1.7 2.9 8.1 13.1 18 13.7 7.9.5 14.9-4.4 14.6-11.6.1 0-.1-.6-.1-.7z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M150.7 84.8h-.1c-1.5-.1-2.5-2.8-2.3-6.1.3-3.2 1.6-5.7 3.1-5.7h.1c.8 0 1.5.8 1.9 2 .4 1.1.5 2.6.4 4.1-.1 1.5-.5 2.9-1.1 4-.5 1.1-1.3 1.7-2 1.7zm-1.8-6.1c-.2 2.5.5 5.4 1.7 5.4.5 0 1.1-.5 1.6-1.3.5-1 .9-2.3 1-3.8.1-1.5 0-2.8-.4-3.9-.3-1-.8-1.5-1.3-1.6-1.2 0-2.3 2.7-2.6 5.2z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M150.7 85h-.1c-1.6-.1-2.7-2.9-2.4-6.3.3-3.3 1.7-5.8 3.2-5.8h.1c.8 0 1.5.8 2 2.1.4 1.1.5 2.6.4 4.2-.1 1.6-.5 3-1.1 4.1-.6 1-1.3 1.7-2.1 1.7zm.9-11.9h-.1c-1.4 0-2.8 2.4-3 5.6-.3 3.2.7 5.9 2.2 6h.1c.7 0 1.4-.5 2-1.6.5-1 1-2.4 1.1-4 .1-1.5 0-3-.4-4.1-.6-1.1-1.2-1.8-1.9-1.9zm-.9 11.2c-.1 0-.1 0 0 0-.4 0-.6-.2-.9-.5-.8-.9-1.2-3-1-5.1.2-2.6 1.4-5.3 2.7-5.2.5 0 1.1.7 1.4 1.7.4 1.1.5 2.5.4 3.9-.1 1.4-.5 2.8-1 3.8-.5.9-1.1 1.4-1.6 1.4zm.8-10.6c-1.1 0-2.2 2.6-2.4 5-.2 2 .2 4.1 1 4.9.2.2.4.4.6.4.5 0 1-.4 1.5-1.3.5-1 .9-2.3 1-3.7.1-1.4 0-2.8-.4-3.9-.3-.8-.8-1.3-1.3-1.4zM107.9 114h-2.5c3.9 15.2 16.9 26.1 16.9 26.1l8.9-10.9 12.4 6.7-2.8-19.6c.5 5.4-4.3 10.9-9.8 11.8-7.1 1.2-16.4-3-23.1-14.1z"
        />
        <path d="M151.6 92.8c-.9 0-2.1-.3-3-1.6l.4-.2c1.4 2 3.5 1.3 3.6 1.3l.1.4s-.5.1-1.1.1z" />
        <path
            className="publish-illustration_svg__st2"
            d="M94.8 252.4V129H200v125.6"
        />
        <path
            className="publish-illustration_svg__st1"
            d="M94.8 132.4V129c0-1 .8-1.8 1.8-1.8h101.6c1 0 1.8.8 1.8 1.8v3.4"
        />
        <path
            d="M229 254.6c0 8-6.5 14.5-14.5 14.5s-14.5-6.5-14.5-14.5"
            fill="#59c3a3"
        />
        <path
            className="publish-illustration_svg__st2"
            d="M94.8 252.4c0 10.3 8.4 18.7 18.7 18.7s18.7-8.4 18.7-18.7"
        />
        <circle
            className="publish-illustration_svg__st4"
            cx={97.9}
            cy={129.8}
            r={1.3}
        />
        <circle
            className="publish-illustration_svg__st4"
            cx={102}
            cy={129.8}
            r={1.3}
        />
        <circle
            className="publish-illustration_svg__st4"
            cx={106}
            cy={129.8}
            r={1.3}
        />
        <path
            className="publish-illustration_svg__st3"
            d="M70.6 116.9c-13.9 3.7-38.6 74.2-42.1 103.4-3 25.6-3.9 38.8 7.8 43.6 8.8 3.6 20-3.5 28.5-17.1C78.4 225 92.7 176 92.7 176l-6.3-6.3-21.5 18.6 5.7-71.4z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M113.6 271.2c10.3 0 18.7-8.4 18.7-18.7h99.5c0 10.3-8.4 18.7-18.7 18.7h-99.5z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M167.4 183.7c-11.9 24.1-2 53.3 22.1 65.2 2.2 1.1 4.5 2 6.8 2.7l3.8 1.1s-.1-7.3-.1-7.4c-1-.4-2.4-.8-2.4-.8-1.7-.6-3.3-1.3-4.9-2-20.6-10.2-29.1-35.1-18.9-55.7 5.4-11.1 15.2-18.6 26.3-21.7 0 0 .2-7.4.1-7.3-13.8 3.2-26.1 12.3-32.8 25.9z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M158.7 179.4c8.4-17 24-28.2 41.4-31.5-.1-2.4-.3-4.8-.5-7.1-19.8 3.5-37.7 16.1-47.3 35.5-16 32.4-2.6 71.8 29.8 87.8 3.1 1.5 6.3 2.8 9.5 3.8.8-2.1 1.6-4.3 2.3-6.7-2.9-.9-5.9-2-8.7-3.4-28.9-14.4-40.8-49.5-26.5-78.4z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M166.2 183.1c6.9-14.1 19.7-23.4 33.9-26.7.1 0 .1-4.9 0-7.3-16.9 3.3-32.1 14.2-40.3 30.8-13.9 28.3-2.3 62.5 26 76.5 2.8 1.4 5.6 2.5 8.5 3.4.6-2.2 1.2-4.5 1.7-6.9-2.4-.8-4.8-1.7-7.1-2.9-24.7-12.1-34.9-42.1-22.7-66.9z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M200.1 166.5c-10.6 3-19.8 10.3-25.1 20.9-9.8 19.9-1.6 44.1 18.3 53.9 1.5.7 3 1.4 4.5 1.9l2.2.6v-7.7l-1.2-.2c-.8-.3-1.6-.7-2.4-1-16.4-8.1-23.2-28-15.1-44.4 4-8.1 10.9-13.8 18.8-16.6v-7.4z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M200 215.3v-20.2c-1 1-1.7 2.2-2.4 3.5-2.8 5.7-1.6 12.4 2.4 16.7z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M200.1 184.6c-4.2 2.2-7.7 5.7-9.9 10.3-5.6 11.3-1.1 24.9 9.8 30.9 0-.6.1-1.1.1-1.7v-6.8c-5.2-4.8-6.8-12.6-3.6-19.2.9-1.9 2.1-3.4 3.6-4.8v-8.7z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M182.5 191.2c-7.8 15.7-1.3 34.9 14.5 42.6 1.5.7 3 1.2 3 1.2v-7.6c-12-6.2-17.1-21-11.2-33.1 2.5-5 6.4-8.8 11.1-11.2v-7.7c-7.2 2.8-13.6 8.2-17.4 15.8zM95.9 132.4c7.9 11.1 8.4 26.4.2 38.2-.4.6-.8 1.2-1.3 1.7v10.2c2.6-2.2 5-4.8 7.1-7.8 9-12.9 9.4-29.3 2.4-42.3h-8.4z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M95.1 169.9c7.9-11.3 7.4-26.1-.2-36.7v37.1c-.1-.2.1-.3.2-.4z"
        />
        <path
            className="publish-illustration_svg__st1"
            d="M200.1 162.7s5-10.7 5-12.6c0-6.9-2.4-12.2-3.4-12.7-4.8-2.6-7.5 0-9 .8s-6.1 3.3-6.1 4.2c0 3.6 1.5 9.4 3.6 9.4s8.1-3 9.9-2.9v13.8z"
        />
        <ellipse
            transform="rotate(-17.801 119.368 40.148)"
            className="publish-illustration_svg__st4"
            cx={119.4}
            cy={40.1}
            rx={10.7}
            ry={9.1}
        />
        <path
            className="publish-illustration_svg__st4"
            d="M126 84.6s-9.3-6.3-4.2-11.6c3.3-3.3 7.3-2.5 7.6 2.7l2.1.2s1-3.6 1.7-6.7c3.7.5 18.4-1 26.4-2.9.9-9.4-12.6-30.6-37.8-20-23.4 9.8-16.1 33.8-11.7 41.6.7 1.2 3.4 7.6 3.4 7.6s4.5-2 5.9-2.9c2.1-1.4 6.6-8 6.6-8z"
        />
        <path
            className="publish-illustration_svg__st1"
            d="M141 69.3l1.3-7.2 2 7.3"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M148.7 77.8l-19.1-2.7c-.2 0-.4.1-.5.4 0 .2.1.4.4.5l19 2.7c.2 0 .4-.2.4-.4.1-.3 0-.5-.2-.5zM124.1 132.4c5.9 17.1 3.9 36.7-7.3 52.7-5.9 8.4-13.5 14.7-22 19v7.8c10.9-4.7 20.6-12.3 27.9-22.7 12-17.1 14.5-38.1 8.9-56.7h-7.5z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M115 132.4c6.4 15.2 5.1 33.3-5 47.8-4.1 5.9-9.3 10.7-15.1 14.2v8.1c8.1-4.1 15.4-10.2 21-18.2 10.9-15.7 12.9-35.1 6.8-51.9H115z"
        />
        <path
            className="publish-illustration_svg__st4"
            d="M105.8 132.4c6.9 13.3 6.4 29.9-2.7 43-2.4 3.4-5.1 6.3-8.2 8.8v8.7c5.4-3.4 10.2-7.8 14-13.4 10-14.3 11.2-32.2 4.8-47.1h-7.9z"
        />
        <path
            className="publish-illustration_svg__st1"
            d="M103.4 150.9s-1.6 7.6-3.2 11.8c-1.6 4.2-6.3 11.5-6.3 11.5s-5.2.9-7.3-5.9c0 0 2-14.7 3.1-16.8 1-2.1 3.1-7.3 5.4-8.6 0 0 4.1-1.9 7-3.8 2.9-1.9 4.4-.9 6.7-.2 1.1.3 2.6.8 3.7 1.3s1.9 1.1 1.5 1.6c-.6 1-1.3 1.9-2.9 2.7-1.9 1-6.9 3.3-7.7 6.4z"
        />
        <path
            className="publish-illustration_svg__st1"
            d="M87.3 166.5c1.2-2.4 1.2-8.3 1.4-10.6.4-5.4 1.5-6.7 2.2-11.6.8-4.9.1-7.3.5-7.5.4-.3 3.3.1 3.4 5.1s0 10.6 0 10.6M129.2 74.3s.2.9.5 3.3c.2 2.4-1-1-1-1v-2"
        />
    </svg>
);

PublishIllustrationSvg.displayName = 'PublishIllustrationSvg';
export default PublishIllustrationSvg;
